// Shared seat/table helpers for the timeslot seat-assignment views
// (SeatAssignmentPage and BookingGroupList).

// Sentinel table id for bookings whose seats map to no table.
export const UNGROUPED_TABLE_KEY = '__ungrouped';

// Sort table entries by display name (natural/numeric), then numeric id, then
// string id, so tables list in a stable, human-friendly order.
export function compareTableEntries(a, b) {
    const byName = (a.tableName || '').localeCompare(b.tableName || '', undefined, {
        sensitivity: 'base',
        numeric: true,
    });
    if (byName !== 0) return byName;
    const numA = Number(a.tableId);
    const numB = Number(b.tableId);
    if (!Number.isNaN(numA) && !Number.isNaN(numB)) return numA - numB;
    return String(a.tableId).localeCompare(String(b.tableId));
}
